var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"m-auto image",attrs:{"src":"/img/logo-degradient.svg","alt":"Workflow","width":"50%"}})}
var staticRenderFns = []

export { render, staticRenderFns }